const ContractNames = {
  RolesAuthority: "RolesAuthority",
  Aggregator: "BondAggregator",
  // Tellers
  FixedExpiryTeller: "BondFixedExpiryTeller",
  FixedTermTeller: "BondFixedTermTeller",
  // Fixed Expiry Auctioneers
  FixedExpiryFPA: "BondFixedExpiryFPA",
  FixedExpiryOFDA: "BondFixedExpiryOFDA",
  FixedExpiryOSDA: "BondFixedExpiryOSDA",
  FixedExpirySDA: "BondFixedExpirySDA",
  // Fixed Term Auctioneers
  FixedTermFPA: "BondFixedTermFPA",
  FixedTermOFDA: "BondFixedTermOFDA",
  FixedTermOSDA: "BondFixedTermOSDA",
  FixedTermSDA: "BondFixedTermSDA",
};

module.exports = {
  ContractNames,
};
